import request from '@/utils/request';

// 移交系统下拉框数据源
export function handoverSysBox(handoverType) {
    return request({
        url: `/market/handover/handoverSysBox/${handoverType}`,
        method: 'get'
    })
}

// 移交部门下拉框数据源
export function handoverShellBox(sysId) {
    return request({
        url: `/market/handover/handoverShellBox/${sysId}`,
        method: 'get'
    })
}

// 移交人下拉框数据源
export function handoverUserBox(shellId) {
    return request({
        url: `/market/handover/handoverUserBox/${shellId}`,
        method: 'get'
    })
}


// 获取锁屏状态
export function getLockStateApi() {
    return request({
        url: `/system/unlock/state`,
        method: 'get'
    })
}